export class CloudProviderFilters {
    '_in';
    'notIn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<Provider>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<Provider>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudProviderFilters.attributeTypeMap;
    }
    constructor() {
    }
}
